import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=5d71840c&scoped=true&"
import script from "./SearchItem.vue?vue&type=script&lang=js&"
export * from "./SearchItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchItem.vue?vue&type=style&index=0&id=5d71840c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71840c",
  null
  
)

export default component.exports